import { route } from '@md/routing';
import { categoriesApi } from '@md/delivery/api';
import { accessPermission } from '@md/users/permissions';
import {
  DELIVERY_CATEGORIES_VIEW_LIST,
  DELIVERY_CATEGORIES_EDIT,
  DELIVERY_CATEGORIES_CREATE,
} from '@md/delivery/accessTokens';
import { receiveRoute } from '@sections/cabinet/components/views/utils';

const List = () => import('./views/List');
const Edit = () => import('./views/Edit');
const Create = () => import('./views/Create');

const CATEGORIES_PREFIX = 'cabinet:delivery:categories:';
const p = name => CATEGORIES_PREFIX + name;
const LIST = p('list');
const EDIT = p('edit');

export function createRoutes(options) {
  return [
    route('list/', List, LIST, {
      meta: accessPermission(DELIVERY_CATEGORIES_VIEW_LIST, options),
    }),
    route('create/', Create, p('create'), {
      meta: accessPermission(DELIVERY_CATEGORIES_CREATE, options),
    }),
    receiveRoute(categoriesApi.retrieve, [
      // route('edit/', List, EDIT, {
      route('edit/', Edit, EDIT, {
        meta: accessPermission(DELIVERY_CATEGORIES_EDIT, options),
      }),
      { path: '', redirect: { name: EDIT } },
    ]),

    { path: '', redirect: { name: LIST } },
  ];
}
